<div class="post-trading-filter">
	<div class="search">
		<tui-input
			[(ngModel)]="searchValue"
			(ngModelChange)="onInputSearch()"
			tuiTextfieldSize="s"
			tuiTextfieldIconLeft="@tui.search"
		>
			<label class="label">{{ 'postTradingFilter.searchTicker' | translate }}</label>
			<input
				class="input"
				tuiTextfieldLegacy
				type="text"
				tuiAutoFocus
			/>
		</tui-input>
	</div>

	<div class="calendar">
		@if (currentDatesRange()) {
			<div class="date">
				<span class="text">
					{{ currentDatesRange()?.from?.toLocalNativeDate() | date: 'dd.MM.yyyy' }}
					–
					{{ currentDatesRange()?.to?.toLocalNativeDate() | date: 'dd.MM.yyyy' }}
				</span>
			</div>
		}

		<app-button
			appClickOutside
			(clickOutside)="toggleCalendar(false)"
			[appearance]="isOpenCalendar() ? 'primary' : 'flat'"
			shape="square"
			size="s"
			iconStart="calendar"
			(clicked)="toggleCalendar(true)"
			[tuiDropdownMinHeight]="280"
			[tuiDropdownMaxHeight]="320"
			[tuiDropdown]="calendarDropdown"
			[tuiDropdownOpen]="isOpenCalendar()"
		/>
	</div>
</div>

<ng-template #calendarDropdown>
	<tui-calendar
		[showAdjacent]="true"
		[value]="currentDatesRange()"
		(dayClick)="onDayClick($event)"
	/>
</ng-template>
